import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=77c85c09&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=77c85c09&scoped=true&lang=less&"
import style1 from "./SideBar.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c85c09",
  null
  
)

export default component.exports